function _reduced(x) {
  return x && x['@@transducer/reduced'] ? x : {
    '@@transducer/value': x,
    '@@transducer/reduced': true
  };
}
module.exports = _reduced;


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/ramda/src/internal/_reduced.js
// module id = 759
// module chunks = 168707334958949